import React, { ReactNode } from 'react';

import { containerClass } from './style.css';

export interface ReportDoubleCardProps {
	children?: [ReactNode, ReactNode];
}

/**
 * ReportCard 두 개를 children으로 받아 두 개의 카드를 나란히 보여주는 컴포넌트
 */
const ReportDoubleCard = ({ children }: ReportDoubleCardProps) => {
	return <div className={containerClass}>{children}</div>;
};

export default ReportDoubleCard;
